export const KEY_INFO_USER= 'id_token_claims_obj';
export const MAX_NUMBER_IMAGE = 5;
export const MIN_PRICE = 1000; //1 nghìn đồng
export const MAX_PRICE = 1000000000; //1 tỉ đồng